export const mockSTranslationMapping = [
  {
    id: '1',
    translationKey: 'SERIAL_NUMBER',
    systemValue: 'Serial number',
    en: 'Serial number',
    fr: 'Numéro de série',
    de: 'Seriennummer',
    es: 'Número de serie',
    it: 'Numero di serie',
    ja: 'シリアルナンバー',
    ko: '일련번호',
    zh: '序列号',
    zhtw: '序號',
    ar: 'رقم سري',
    ru: 'Серийный номер',
  }
];
